 /**
 2  * [通过参数名获取url中的参数值]
 3  * 示例URL:http://htmlJsTest/getrequest.html?uid=admin&rid=1&fid=2&name=小明
 4  * @param  {[string]} queryName [参数名]
 5  * @return {[string]}           [参数值]
 6  */
let GetQueryValue = (queryName)=> {
     var query = decodeURI(window.location.search.substring(1));
     var vars = query.split("&");
     for (var i = 0; i < vars.length; i++) {
         var pair = vars[i].split("=");
         if (pair[0] == queryName) { return pair[1]; }
     }
     return null;
}
export default {
	GetQueryValue
}


// WEBPACK FOOTER //
// ./src/common/utils.js